function Footer() {
  return (
    <footer className="footer footer-minimal">
      <div className="footer-main">
        <div className="container">
          <div className="row items align-items-center">
            <div className="col-lg-3 col-md-4 col-12 item">
              <div className="widget-brand-info">
                <div className="widget-brand-info-main">
                  <a href="/" className="logo" title="AM Systems">
                    <img
                      data-src="/images/logo-navbar.png"
                      className="lazy"
                      width="133"
                      height="36"
                      src="/images/logo-navbar.png"
                      alt="AM Systems"
                      data-loaded="true"
                      style={{ opacity: 1 }}
                    />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-md item">
              <div className="footer-item">
                <nav className="footer-nav">
                  <ul className="footer-mnu footer-mnu-line">
                    <li>
                      <a href="#intro" className="hover-link" data-title="Início">
                        <span>Início</span>
                      </a>
                    </li>
                    <li>
                      <a href="#services" className="hover-link" data-title="Serviços">
                        <span>Serviços</span>
                      </a>
                    </li>
                    <li>
                      <a href="#choose" className="hover-link" data-title="Diferenciais">
                        <span>Diferenciais</span>
                      </a>
                    </li>
                    <li>
                      <a href="#contact-form" className="hover-link" data-title="Contato">
                        <span>Contato</span>
                      </a>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <div className="container">
          <div className="row justify-content-between items">
            <div className="col-md-auto col-12 item">
              <nav className="footer-links">
                <ul>
                  <li>
                    <span>Rua 7 de maio, 564 - Itoupava Norte - Blumenau - SC</span>
                  </li>
                  <li>
                    <a href="tel:+5547999876097">(47) 99987-6097</a>
                  </li>
                </ul>
              </nav>
            </div>
            <div className="col-md-auto col-12 item">
              <div className="copyright">© 2025 AM Systems. Todos os direitos reservados.</div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
